// src/components/grid/grid.types.ts
var gridColValues = ["hidden", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var gridColOffsetValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var gridColAlignmentValues = ["left", "right", "center", "justify"];

export {
  gridColValues,
  gridColOffsetValues,
  gridColAlignmentValues
};
